'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherDollarSign, FeatherFileText, FeatherInfo } from '@subframe/core';
import { useEffect, useState } from 'react';
import { Button, Dialog } from '@/shared/components/ui';
import { formatarDataCurta, formatarMoedaBR } from '../utils/faturaFormatters';
interface GerarFaturaApuracaoModalProps {
  isOpen: boolean;
  tenantNome: string;
  produtoNome: string;
  periodoInicio: string;
  periodoFim: string;
  totalCobravel: number;
  totalEventos: number;
  diaVencimento: number;
  saving: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
const computarPrevisaoVencimento = (periodoFim: string, diaVencimento: number): string => {
  const fim = new Date(periodoFim);
  return new Date(fim.getFullYear(), fim.getMonth() + 1, diaVencimento).toISOString();
};
export function GerarFaturaApuracaoModal(t0) {
  const $ = _c(98);
  const {
    isOpen,
    tenantNome,
    produtoNome,
    periodoInicio,
    periodoFim,
    totalCobravel,
    totalEventos,
    diaVencimento,
    saving,
    onClose,
    onConfirm
  } = t0;
  const [ciente, setCiente] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isOpen) {
    t1 = () => {
      if (isOpen) {
        setCiente(false);
      }
    };
    t2 = [isOpen];
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let T0;
  let T1;
  let podeConfirmar;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== ciente || $[4] !== diaVencimento || $[5] !== isOpen || $[6] !== onClose || $[7] !== periodoFim || $[8] !== periodoInicio || $[9] !== produtoNome || $[10] !== saving || $[11] !== tenantNome || $[12] !== totalCobravel || $[13] !== totalEventos) {
    const previsaoVencimento = computarPrevisaoVencimento(periodoFim, diaVencimento);
    podeConfirmar = ciente && !saving;
    T1 = Dialog;
    t13 = isOpen;
    t14 = onClose;
    T0 = Dialog.Content;
    t12 = "max-w-lg";
    t10 = "flex w-full flex-col gap-5 p-6";
    let t15;
    let t16;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <div className="bg-brand-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"><FeatherDollarSign className="text-brand-600 h-5 w-5" /></div>;
      t16 = <h2 className="text-body-bold font-body-bold text-default-font">Gerar fatura desta apuração</h2>;
      $[29] = t15;
      $[30] = t16;
    } else {
      t15 = $[29];
      t16 = $[30];
    }
    if ($[31] !== produtoNome || $[32] !== tenantNome) {
      t11 = <div className="flex items-start gap-3">{t15}<div>{t16}<p className="text-caption font-caption text-subtext-color mt-1">{tenantNome} · {produtoNome}</p></div></div>;
      $[31] = produtoNome;
      $[32] = tenantNome;
      $[33] = t11;
    } else {
      t11 = $[33];
    }
    t6 = "grid grid-cols-2 gap-3 rounded-[12px] bg-neutral-50 p-4";
    let t17;
    if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = <p className="text-caption font-caption text-subtext-color">Período</p>;
      $[34] = t17;
    } else {
      t17 = $[34];
    }
    let t18;
    if ($[35] !== periodoInicio) {
      t18 = formatarDataCurta(periodoInicio);
      $[35] = periodoInicio;
      $[36] = t18;
    } else {
      t18 = $[36];
    }
    let t19;
    if ($[37] !== periodoFim) {
      t19 = formatarDataCurta(periodoFim);
      $[37] = periodoFim;
      $[38] = t19;
    } else {
      t19 = $[38];
    }
    if ($[39] !== t18 || $[40] !== t19) {
      t7 = <div>{t17}<p className="text-body font-body text-default-font mt-1">{t18} → {t19}</p></div>;
      $[39] = t18;
      $[40] = t19;
      $[41] = t7;
    } else {
      t7 = $[41];
    }
    let t20;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <p className="text-caption font-caption text-subtext-color">Eventos apurados</p>;
      $[42] = t20;
    } else {
      t20 = $[42];
    }
    if ($[43] !== totalEventos) {
      t8 = <div>{t20}<p className="text-body font-body text-default-font mt-1">{totalEventos}</p></div>;
      $[43] = totalEventos;
      $[44] = t8;
    } else {
      t8 = $[44];
    }
    let t21;
    if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <p className="text-caption font-caption text-subtext-color">Valor da fatura</p>;
      $[45] = t21;
    } else {
      t21 = $[45];
    }
    let t22;
    if ($[46] !== totalCobravel) {
      t22 = formatarMoedaBR(totalCobravel);
      $[46] = totalCobravel;
      $[47] = t22;
    } else {
      t22 = $[47];
    }
    if ($[48] !== t22) {
      t9 = <div>{t21}<p className="text-heading-3 font-heading-3 text-brand-700 mt-1">{t22}</p></div>;
      $[48] = t22;
      $[49] = t9;
    } else {
      t9 = $[49];
    }
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <p className="text-caption font-caption text-subtext-color">Vencimento previsto</p>;
      $[50] = t5;
    } else {
      t5 = $[50];
    }
    t3 = "text-body-bold font-body-bold text-default-font mt-1";
    t4 = formatarDataCurta(previsaoVencimento);
    $[3] = ciente;
    $[4] = diaVencimento;
    $[5] = isOpen;
    $[6] = onClose;
    $[7] = periodoFim;
    $[8] = periodoInicio;
    $[9] = produtoNome;
    $[10] = saving;
    $[11] = tenantNome;
    $[12] = totalCobravel;
    $[13] = totalEventos;
    $[14] = T0;
    $[15] = T1;
    $[16] = podeConfirmar;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    T0 = $[14];
    T1 = $[15];
    podeConfirmar = $[16];
    t10 = $[17];
    t11 = $[18];
    t12 = $[19];
    t13 = $[20];
    t14 = $[21];
    t3 = $[22];
    t4 = $[23];
    t5 = $[24];
    t6 = $[25];
    t7 = $[26];
    t8 = $[27];
    t9 = $[28];
  }
  let t15;
  if ($[51] !== t3 || $[52] !== t4) {
    t15 = <p className={t3}>{t4}</p>;
    $[51] = t3;
    $[52] = t4;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== t15 || $[55] !== t5) {
    t16 = <div>{t5}{t15}</div>;
    $[54] = t15;
    $[55] = t5;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  let t17;
  if ($[57] !== t16 || $[58] !== t6 || $[59] !== t7 || $[60] !== t8 || $[61] !== t9) {
    t17 = <div className={t6}>{t7}{t8}{t9}{t16}</div>;
    $[57] = t16;
    $[58] = t6;
    $[59] = t7;
    $[60] = t8;
    $[61] = t9;
    $[62] = t17;
  } else {
    t17 = $[62];
  }
  let t18;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <FeatherInfo className="text-brand-700 mt-0.5 h-4 w-4 shrink-0" />;
    $[63] = t18;
  } else {
    t18 = $[63];
  }
  let t19;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <p>A fatura será criada com tipo de geração{" "}<span className="font-semibold">Manual</span> e enviada ao Asaas para gerar a cobrança. O cliente receberá os lembretes automaticamente.</p>;
    $[64] = t19;
  } else {
    t19 = $[64];
  }
  let t20;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="border-brand-200 bg-brand-50 flex items-start gap-3 rounded-[8px] border px-4 py-3 text-sm">{t18}<div className="text-brand-800 flex flex-col gap-1">{t19}<p>A apuração será marcada como <span className="font-semibold">faturada</span> e ficará vinculada a esta fatura.</p></div></div>;
    $[65] = t20;
  } else {
    t20 = $[65];
  }
  let t21;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = e => setCiente(e.target.checked);
    $[66] = t21;
  } else {
    t21 = $[66];
  }
  let t22;
  if ($[67] !== ciente) {
    t22 = <input type="checkbox" checked={ciente} onChange={t21} className="accent-brand-600 mt-0.5 h-4 w-4 rounded border-neutral-300" />;
    $[67] = ciente;
    $[68] = t22;
  } else {
    t22 = $[68];
  }
  let t23;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <span className="text-sm text-neutral-700">Confirmo os valores e desejo gerar a fatura agora</span>;
    $[69] = t23;
  } else {
    t23 = $[69];
  }
  let t24;
  if ($[70] !== t22) {
    t24 = <label className="flex cursor-pointer items-start gap-3">{t22}{t23}</label>;
    $[70] = t22;
    $[71] = t24;
  } else {
    t24 = $[71];
  }
  let t25;
  if ($[72] !== onClose || $[73] !== saving) {
    t25 = <Button variant="neutral-secondary" size="medium" onClick={onClose} disabled={saving}>Cancelar</Button>;
    $[72] = onClose;
    $[73] = saving;
    $[74] = t25;
  } else {
    t25 = $[74];
  }
  let t26;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <FeatherFileText />;
    $[75] = t26;
  } else {
    t26 = $[75];
  }
  const t27 = !podeConfirmar;
  let t28;
  if ($[76] !== onConfirm || $[77] !== saving || $[78] !== t27) {
    t28 = <Button variant="brand-primary" size="medium" icon={t26} onClick={onConfirm} loading={saving} disabled={t27}>Gerar fatura</Button>;
    $[76] = onConfirm;
    $[77] = saving;
    $[78] = t27;
    $[79] = t28;
  } else {
    t28 = $[79];
  }
  let t29;
  if ($[80] !== t25 || $[81] !== t28) {
    t29 = <div className="flex items-center justify-end gap-2 border-t border-neutral-100 pt-4">{t25}{t28}</div>;
    $[80] = t25;
    $[81] = t28;
    $[82] = t29;
  } else {
    t29 = $[82];
  }
  let t30;
  if ($[83] !== t10 || $[84] !== t11 || $[85] !== t17 || $[86] !== t24 || $[87] !== t29) {
    t30 = <div className={t10}>{t11}{t17}{t20}{t24}{t29}</div>;
    $[83] = t10;
    $[84] = t11;
    $[85] = t17;
    $[86] = t24;
    $[87] = t29;
    $[88] = t30;
  } else {
    t30 = $[88];
  }
  let t31;
  if ($[89] !== T0 || $[90] !== t12 || $[91] !== t30) {
    t31 = <T0 className={t12}>{t30}</T0>;
    $[89] = T0;
    $[90] = t12;
    $[91] = t30;
    $[92] = t31;
  } else {
    t31 = $[92];
  }
  let t32;
  if ($[93] !== T1 || $[94] !== t13 || $[95] !== t14 || $[96] !== t31) {
    t32 = <T1 open={t13} onOpenChange={t14}>{t31}</T1>;
    $[93] = T1;
    $[94] = t13;
    $[95] = t14;
    $[96] = t31;
    $[97] = t32;
  } else {
    t32 = $[97];
  }
  return t32;
}